export interface ReportRecord {
  id: string;
  reportType: 'daily' | 'weekly' | 'monthly';
  templateType: 'summary' | 'full';
  content: string;
  summaryContent: string;
  channels: Array<{ id: string; name: string; icon: string }>;
  sentAt: number;
  isScheduled: boolean;
  scheduledAt?: number;
  status: 'sent' | 'scheduled';
}

type Listener = (records: ReportRecord[]) => void;

class ReportHistoryStore {
  private records: ReportRecord[] = [];
  private listeners: Set<Listener> = new Set();

  constructor() {
    try {
      const saved = localStorage.getItem('report-history-v1');
      if (saved) this.records = JSON.parse(saved);
    } catch {
      this.records = [];
    }
  }

  add(record: ReportRecord): void {
    this.records = [record, ...this.records].slice(0, 100);
    this.persist();
    this.notify();
  }

  updateStatus(id: string, status: 'sent' | 'scheduled'): void {
    this.records = this.records.map(r => r.id === id ? { ...r, status } : r);
    this.persist();
    this.notify();
  }

  getAll(): ReportRecord[] {
    return [...this.records];
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  private persist(): void {
    try {
      localStorage.setItem('report-history-v1', JSON.stringify(this.records));
    } catch {
      // ignore
    }
  }

  private notify(): void {
    this.listeners.forEach(fn => fn([...this.records]));
  }
}

export const reportHistoryStore = new ReportHistoryStore();
